import React, { useEffect, useState } from "react";
import SidebarHeaderLayout from "../../HOC/SidebarHeaderLayout";
import { createHotelRoomType, getAllHotel } from "../../../api-core/Hotel";
import { useFormik } from "formik";
import * as Yup from "yup";
const CreateHotelRoomType = () => {
  const [hotels, setHotels] = useState([]);
  const initialValues = {
    hotel_id: "",
    beds: "",
    max_occupancy: "",
    room_type_name: "",
    cost_per_night: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      hotel_id: Yup.string().required("Hotel name is required"),
      beds: Yup.string().required("bed type is required"),
      max_occupancy: Yup.string().required("max Occupancy is required"),
      room_type_name: Yup.string().required("Room Type is required"),
      cost_per_night: Yup.string().required("Cost is required"),
    }),
    onSubmit: async (values, action) => {
      console.log("values", values);

      if (values) {
        const res = await createHotelRoomType(values);
        console.log("resHotelRoom", res);
        action.resetForm();
      } else {
        console.log("error");
      }
    },
  });

  useEffect(() => {
    const fetchAllHotel = async () => {
      const res = await getAllHotel();
      setHotels(res.hotel);
    };
    fetchAllHotel();
  }, []);
  return (
    <div className="w-[90%] mx-auto ">
      <h1>Create Hotel Room Type</h1>
      <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
        <div className="flex flex-col justify-center items-center  md:justify-between md:flex-row gap-x-5 flex-wrap">
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Hotel Id
            </label>
            <select
              value={formik.values.hotel_id}
              name="hotel_id"
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value={""}>Select Hotel</option>
              {hotels.map((value) => (
                <option value={value._id} key={value._id}>
                  {value.hotel_name}
                </option>
              ))}
            </select>
            {formik.errors.hotel_id && (
              <span className="text-red-500">{formik.errors.hotel_id}</span>
            )}
          </div>

          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Beds
            </label>
            <input
              type="text"
              name="beds"
              value={formik.values.beds}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter Beds"
            />
            {formik.errors.beds && (
              <span className="text-red-500">{formik.errors.beds}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Max Occupancy
            </label>
            <input
              type="number"
              name="max_occupancy"
              value={formik.values.max_occupancy}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter Occupancy"
            />
            {formik.errors.max_occupancy && (
              <span className="text-red-500">{formik.errors.max_occupancy}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Room Type
            </label>
            <input
              type="text"
              name="room_type_name"
              value={formik.values.room_type_name}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="enter RoomType"
            />
            {formik.errors.room_type_name && (
              <span className="text-red-500">{formik.errors.room_type_name}</span>
            )}
          </div>
          <div className="mb-6 w-[95%] md:w-[45%] ">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              Room Cost Per Night
            </label>
            <input
              type="number"
              name="cost_per_night"
              value={formik.values.cost_per_night}
              onChange={formik.handleChange}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Enter Room Cost"
            />
            {formik.errors.cost_per_night && (
              <span className="text-red-500">{formik.errors.cost_per_night}</span>
            )}
          </div>
        </div>
        <button
          type="submit"
          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-[50%] sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default SidebarHeaderLayout(CreateHotelRoomType);
